var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    ref: "hero",
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "main-container"
  }), !_vm.isMobile ? [!_vm.videoLoaded ? _c('img', {
    staticClass: "background",
    attrs: {
      "alt": "Background",
      "src": _vm.field.value.desktop_image
    }
  }) : _vm._e(), _c('video', {
    ref: "video",
    staticClass: "background",
    attrs: {
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "preload": "auto",
      "muted": "",
      "src": _vm.field.value.desktop_video
    },
    domProps: {
      "muted": true
    },
    on: {
      "play": _vm.onPlay
    }
  })] : _vm._e(), _vm.isMobile ? [!_vm.videoLoaded ? _c('img', {
    staticClass: "background",
    attrs: {
      "alt": "Background",
      "src": _vm.field.value.mobile_image
    }
  }) : _vm._e(), _c('video', {
    ref: "video",
    staticClass: "background",
    attrs: {
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "preload": "auto",
      "muted": "",
      "src": _vm.field.value.mobile_video
    },
    domProps: {
      "muted": true
    },
    on: {
      "play": _vm.onPlay
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }